import { render, staticRenderFns } from "./PracticeContent.vue?vue&type=template&id=ea507a08&"
import script from "./PracticeContent.vue?vue&type=script&lang=ts&"
export * from "./PracticeContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports